@if(isReady){
<kendo-chart>
  <kendo-chart-title ></kendo-chart-title>
  <kendo-chart-value-axis>
    <kendo-chart-value-axis-item [plotBands]="plotBands">
    </kendo-chart-value-axis-item>
  </kendo-chart-value-axis>
  <kendo-chart-series>
    <kendo-chart-series-item type="line" color="gray" [markers]="{ visible: true }" [data]="historicalExamRecordsData" field="temperature" categoryField="day">
  <kendo-chart-series-item-markers
        background="#1bbf9c"
        [border]="{ color: '#ffffff', width: 2 }">
    </kendo-chart-series-item-markers>
    </kendo-chart-series-item >
  </kendo-chart-series>
</kendo-chart>
}
